import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuth } from '../contexts/AuthContext';
import type { UserRole } from '../services/api/client';

/**
 * Guarda de rota no cliente.
 *
 * ATENCAO: isto e conveniencia de navegacao, NAO seguranca. Quem impede o
 * acesso de verdade e o backend (preHandlers requireAuth/requireRole). Esta
 * guarda so evita que o usuario veja uma tela quebrada ou um 403 feio.
 */
export function ProtectedRoute({ allowedRoles }: { allowedRoles?: UserRole[] }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="centered-state">
        <p>Verificando sessão…</p>
      </div>
    );
  }

  if (!user) {
    // `state` guarda de onde a pessoa veio, para voltar ao destino apos o login.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
